import { createSelector } from 'reselect'

export const getIncomingMailsDomain = (state, props) => {
  return state.kanbo.config.incomingMailDomain
}

export const getIsLoading = (state, props) => {
  return state['view-card'].incomingMails[props.cardId].isLoading
}

export const getIsLoaded = (state, props) => {
  return state['view-card'].incomingMails[props.cardId].isLoaded
}

export const getCardId = (state, props) => props.cardId

export const getIncomingMailNames = (state, props) => {
  return state.kanbo.incomingMails.names
}

export const getIncomingMailsByName = (state, props) => {
  return state.kanbo.incomingMails.byName
}

export const incomingMailsSelector = createSelector(
  [getCardId, getIncomingMailNames, getIncomingMailsByName],
  (cardId, incomingMailNames, incomingMailsByName) => {
    return incomingMailNames
      .map(name => incomingMailsByName[name])
      .filter(incomingMail => incomingMail.cardId === cardId)
  }
)

export const publicIncomingMailNameSelector = createSelector(
  [incomingMailsSelector],
  (incomingMails) => {
    const incomingMail = incomingMails[0]

    if (!incomingMail) return null

    return incomingMail.name
  }
)

export const publicIncomingMailValidateAddressSelector = createSelector(
  [incomingMailsSelector],
  (incomingMails) => {
    const incomingMail = incomingMails[0]

    if (!incomingMail) return null

    return incomingMail.validateAddress
  }
)

export default createSelector(
  [
    getIncomingMailsDomain,
    getIsLoading,
    getIsLoaded,
    publicIncomingMailNameSelector,
    publicIncomingMailValidateAddressSelector,
  ],
  (
    incomingMailsDomain,
    isLoading,
    isLoaded,
    publicIncomingMailName,
    publicIncomingMailValidateAddress,
  ) => ({
    incomingMailsDomain,
    isLoading,
    isLoaded,
    publicIncomingMailName,
    publicIncomingMailValidateAddress,
  })
)
